import React, { useEffect, useState } from "react";
import SettingsCard from "./SettingsCard";
import GoogleIcon from "../assets/images/googleicon.svg";
import MicrosoftIcon from "../assets/images/microsoft.svg";

const SettingsComponent = ({ data }) => {
  const [isGoogleSSOEnabled, setIsGoogleSSOEnabled] = useState(false);
  const [isMicrosoftSSOEnabled, setIsMicrosoftSSOEnabled] = useState(false);
  const [googleClientId, setGoogleClientId] = useState("");
  const [microsoftClientId, setMicrosoftClientId] = useState("");
  useEffect(() => {
    if (data) {
      if (data?.enable_google_sso) {
        setIsGoogleSSOEnabled(data?.enable_google_sso);
      }
      if (data?.enable_microsoft_sso) {
        setIsMicrosoftSSOEnabled(data?.enable_microsoft_sso);
      }
      if (data?.google_sso_client_id) {
        setGoogleClientId(data?.google_sso_client_id);
      }
      if (data?.microsoft_sso_client_id) {
        setMicrosoftClientId(data?.microsoft_sso_client_id);
      }
    }
  }, [data]);
  return (
    <>
      <div className="settings-sso-container">
        <SettingsCard
          Icon={GoogleIcon}
          title="Google SSO"
          desc="Securely sign in with your Google account using one-click
          authentication."
          company="google"
          isToggleEnabled={isGoogleSSOEnabled}
          clientId={googleClientId}
        />
        <SettingsCard
          Icon={MicrosoftIcon}
          title="Microsoft SSO"
          desc="Securely sign in with your Microsoft account using one-click
          authentication."
          company="microsoft"
          isToggleEnabled={isMicrosoftSSOEnabled}
          clientId={microsoftClientId}
        />
      </div>
    </>
  );
};

export default SettingsComponent;
